import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCheckoutBillingStore = create(
  persist(
    (set) => ({
      countryCodeBilling: null,
      productId: null,
      paypalProductId: null,
      extensionToken: null,
      showPaymentForm: false,
      extensionURL: null,
      purchasedPlan: null,
      unsupportedMollieCurrency: false,
      mollieTransactionId: null,
      unsupportedRevolutCurrency: false,
      unsupportedPaypalCurrency: false,
      setUnsupportedPaypalCurrency: (unsupportedPaypalCurrency) => set({ unsupportedPaypalCurrency }),
      setUnsupportedRevolutCurrency: (unsupportedRevolutCurrency) => set({ unsupportedRevolutCurrency }),
      setUnsupportedMollieCurrency: (unsupportedMollieCurrency) => set({ unsupportedMollieCurrency }),
      isAiEnabledCountry: false,
      setExtensionURL: (extensionURL) => set({ extensionURL }),
      setIsAiEnabledCountry: (isAiEnabledCountry) => set({ isAiEnabledCountry }),
      setShowPaymentForm: (showPaymentForm) => set({ showPaymentForm }),
      setExtensionToken: (extensionToken) => set({ extensionToken }),
      setProductId: (productId) => set({ productId }),
      setPaypalProductId: (paypalProductId) => set({ paypalProductId }),
      setCountryCodeBilling: (countryCodeBilling) => set({ countryCodeBilling }),
      setPurchasedPlan: (purchasedPlan) => set({ purchasedPlan }),
      setMollieTransactionId: (mollieTransactionId) => set({ mollieTransactionId }),
    }),
    {
      name: 'billing-store',
      partialize: (state) => ({
        productId: state.productId,
        purchasedPlan: state.purchasedPlan,
        mollieTransactionId: state.mollieTransactionId,
      }),
    },
  ),
);
